export const OVERVIEW = ["HR", "MANAGER", "EMPLOYEE"]
export const SCOPE = ["HR", "MANAGER", "EMPLOYEE"]
export const MANAGE = ["HR"]